import * as moment from 'moment-timezone';
import { DEFAULT_DELIVERY_TIME, DELIVERY_TIME_DISPLAY_FORMAT, } from '../constants';
/**
 * Returns a list of time strings in a specific format
 * in intervalInMins increments
 * that is bounded by the
 * startTime and endTime inclusively
 */
export var getTimeOptions = function (startTime, endTime, intervalInMins, timeFormat) {
    var startTimeInMoment = moment(startTime, timeFormat);
    var endTimeInMoment = moment(endTime, timeFormat);
    var timeOptions = [];
    var loopTimeInMoment = startTimeInMoment;
    while (loopTimeInMoment.isSameOrBefore(endTimeInMoment)) {
        timeOptions.push(loopTimeInMoment.format(timeFormat));
        loopTimeInMoment = loopTimeInMoment.add(intervalInMins, 'minutes');
    }
    return timeOptions;
};
/**
 * Returns a list of object
 * of the time range strings and value in a specific format
 * in intervalInMins increments
 * that is bounded by the
 * startTime and endTime inclusively
 *
 * Note:
 * last end time in time range should be on or before input endTime
 */
export var getTimeRangeOptions = function (startTime, endTime, intervalInMins, timeFormat) {
    var startTimeInMoment = moment(startTime, timeFormat);
    var endTimeInMoment = moment(endTime, timeFormat);
    // calculate last valid start time to ensure time range end time is before endTime param
    var lastValidStartTime = endTimeInMoment.subtract(intervalInMins, 'minutes');
    var timeOptions = [];
    var loopTimeInMoment = startTimeInMoment;
    while (loopTimeInMoment.isSameOrBefore(lastValidStartTime)) {
        // Note: Moment.add updates actual object, so there is no need to reassign value to loopTimeInMoment
        // used to help calculate time range midway point
        var halfOfIntervalInMins = intervalInMins / 2;
        // time range start
        var timeRangeStart = loopTimeInMoment;
        var formattedTimeRangeStart = timeRangeStart.format(timeFormat);
        // actual value is the midway point
        var timeValue = loopTimeInMoment.add(halfOfIntervalInMins, 'minutes');
        var formattedTimeValue = timeValue.format(timeFormat);
        // time range end
        var timeRangeEnd = loopTimeInMoment.add(halfOfIntervalInMins, 'minutes');
        var formattedTimeRangeEnd = timeRangeEnd.format(timeFormat);
        var timeRangeDisplay = formattedTimeRangeStart + " - " + formattedTimeRangeEnd;
        timeOptions.push({ value: formattedTimeValue, display: timeRangeDisplay });
    }
    return timeOptions;
};
// returns a time range from a midway time value
export var getTimeRangeFromTimeValue = function (timeValue, intervalInMins, timeFormat) {
    // used to help calculate range since timeValue is midway point
    var halfOfIntervalInMins = intervalInMins / 2;
    // time range start
    var timeRangeStart = moment(timeValue, timeFormat).subtract(halfOfIntervalInMins, 'minutes');
    var formattedTimeRangeStart = timeRangeStart.format(timeFormat);
    // time range end
    var timeRangeEnd = moment(timeValue, timeFormat).add(halfOfIntervalInMins, 'minutes');
    var formattedTimeRangeEnd = timeRangeEnd.format(timeFormat);
    return formattedTimeRangeStart + " - " + formattedTimeRangeEnd;
};
export var getDefaultDeliveryTimeForCurrentDay = function (timeRangeOptions, defaultDeliveryTime, currentTime) {
    if (defaultDeliveryTime === void 0) { defaultDeliveryTime = DEFAULT_DELIVERY_TIME; }
    if (currentTime === void 0) { currentTime = moment(); }
    var DATE_FORMAT = 'YYYY-MM-DD';
    var officeCurrentDate = currentTime.format(DATE_FORMAT);
    // 1 hr and 20 mins buffer time to set the delivery time range
    var officeCurrentTimePlusBuffer = currentTime
        .add({ hours: 1, minutes: 20 })
        .format(DATE_FORMAT + " " + DELIVERY_TIME_DISPLAY_FORMAT);
    // currentTime is mutated! The moment object is mutable
    var defaultDeliveryDateTime = officeCurrentDate + " " + defaultDeliveryTime;
    if (moment(officeCurrentTimePlusBuffer).isSameOrBefore(defaultDeliveryDateTime)) {
        return defaultDeliveryTime;
    }
    var foundTime = timeRangeOptions.find(function (timeRange) {
        var timeRangeValue = moment(officeCurrentDate + " " + timeRange.value, DATE_FORMAT + " " + DELIVERY_TIME_DISPLAY_FORMAT);
        return timeRangeValue.isSameOrAfter(officeCurrentTimePlusBuffer);
    });
    return (foundTime === null || foundTime === void 0 ? void 0 : foundTime.value) || defaultDeliveryTime;
};
